import styled from "styled-components";
import { ButtonBase, Card, CardMedia, Typography } from "@mui/material";

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export const Subtitle = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export const GetStartedButton = styled(ButtonBase)`
  && {
    width: 175px;
    height: 50px;
    background: #f2753b;
    border-radius: 5px;
    text-transform: capitalize;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const CardBody = styled(Card)`
  && {
    background: #ffffff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25), 0px 0px 2px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
  }
`;

export const CardTitle = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 13px;
  }
`;

export const CardSubtitle = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export const CardIcon = styled(CardMedia)`
  && {
    object-fit: contain;
    position: relative;
    margin: auto;
  }
`;
